import { atom } from 'recoil'

export type LeftDrawerAtomType = {
  isOpen: boolean
  disable: boolean
}

export const leftDrawerAtom = atom<LeftDrawerAtomType>({
  key: 'leftDrawerState',
  default: {
    isOpen: false,
    disable: false,
  },
})
